module.exports = __webpack_public_path__ + "img/changyou.e8813104.jpg";